import React from 'react';

import { DEMAND_UNITS, DEMAND_UNIT_LABELS } from './insulationPickerView.js';

/**
 * Потребность — одна на всю таблицу, а не по строке.
 *
 * Менеджер считает объект целиком: «нужно 1000 м²». Сравнивать предложения надо
 * под эту цифру, поэтому она вводится один раз, а каждая строка сама
 * пересчитывает её в свои упаковки.
 */
const InsulationPickerDemand = ({ demand, onChangeValue, onChangeUnit }) => (
  <div className="ins-pick__demand">
    <label className="ins-pick__demand-label" htmlFor="ins-pick-demand">
      Нужно
    </label>

    <input
      id="ins-pick-demand"
      type="text"
      inputMode="decimal"
      className="ins-pick__demand-input"
      placeholder="объём"
      value={demand.value}
      onChange={(event) => onChangeValue(event.target.value)}
    />

    <div className="ins-pick__demand-units" role="group" aria-label="Единица измерения">
      {[DEMAND_UNITS.PACK, DEMAND_UNITS.AREA, DEMAND_UNITS.VOLUME].map((unit) => (
        <button
          key={unit}
          type="button"
          className={`ins-pick__demand-unit${demand.unit === unit ? ' is-active' : ''}`}
          aria-pressed={demand.unit === unit}
          onClick={() => onChangeUnit(unit)}
        >
          {DEMAND_UNIT_LABELS[unit]}
        </button>
      ))}
    </div>

    {demand.value ? (
      <span className="ins-pick__demand-note">
        Упаковки целые, поэтому количество округляется вверх — сколько выйдет на самом деле,
        видно в колонке «Итого».
      </span>
    ) : (
      <span className="ins-pick__demand-note">
        Укажите потребность — и каждое предложение посчитается под неё.
      </span>
    )}
  </div>
);

export default InsulationPickerDemand;
